export const debounce = (callback, wait) => {
  let timeout;

  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
};

export const throttle = (callback, delay) => {
  let throttleTimeout = null;
  let storedEvent = null;

  const throttledEventHandler = event => {
    storedEvent = event;

    const shouldHandleEvent = !throttleTimeout;

    if (shouldHandleEvent) {
      callback(storedEvent);

      storedEvent = null;

      throttleTimeout = setTimeout(() => {
        throttleTimeout = null;

        if (storedEvent) {
          throttledEventHandler(storedEvent);
        }
      }, delay);
    }
  };

  return throttledEventHandler;
};

// Allow click to work with spacebar.
export const a11yClick = (event) => {
  if (event.type === 'click') {
    return true;
  }
  else if (event.type === 'keyup') {
    let code = event.charCode || event.keyCode;

    if ((code === 32) || (code === 13)) {
      return true;
    }
  }
  else {
    return false;
  }
};
